import { GtmEvents } from '@/gtm/gtm-events';
import { getDeliveryInterval } from '@/utils/delivery-utils';

export class ProductGtmEvents extends GtmEvents {
  eventCategory = 'СобытияВКарточке';

  getDeliveryInfo({ activeSku }) {
    const deliveryInfo = activeSku?.delivery || {};
    const storesCount = activeSku?.pickup?.store?.storesCount || 0;
    const delayedCount = activeSku?.pickup?.delayed?.storesCount || 0;
    const availabilityCount = storesCount || delayedCount;
    const deliveryInterval = getDeliveryInterval(deliveryInfo?.interval);
    const isThirdParty = !!activeSku?.pickup?.thirdParty;

    return {
      deliveryInterval,
      availabilityCount,
      isThirdParty,
    };
  }
}
